import React, { useState } from 'react';
import { useNotify, useDataProvider, Button, useRefresh } from 'react-admin';

const ApprovePurchaseOrderBtn = ({ id }) => {
  const notify = useNotify();
  const dataProvider = useDataProvider();
  const refresh = useRefresh();
  const [loading, setLoading] = useState(false);

  const handleClick = () => {
    setLoading(true);
    dataProvider.patch(`skills/purchaseOrders/${id}/approve`, {})
      .then(() => {
        notify('Order approved successfully', 'success');
      })
      .catch((e) => {
        console.log(e);
        notify('Error: order not approved', 'warning');
      })
      .finally(() => {
        setLoading(false);
        refresh();
      });
  };

  return (
    <Button 
      onClick={handleClick} 
      label="Зөвшөөрөх" 
      disabled={loading}
      style={{ 
        backgroundColor: '#4CAF50', 
        color: 'white',
        marginRight: '8px' 
      }}
    />
  );
};

export default ApprovePurchaseOrderBtn; 